import _ from 'underscore';
import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Text,
  Button,
  mergeClasses,
  Image,
} from '@fluentui/react-components';

import { ComponyPageItem } from '../shared-components';
import { useRequestAccessStageStyles } from '../styles/request-access-stage-styles';
import PERMISSION_REQUIRED_LOGO_SRC from '../../media/permission-required-logo.svg';
import { COMPANY_PAGE_LINKING_ACTIONS } from '../reducer';
import { useSaveCompanyPage } from '../hooks';

export const RequestAccessStage = (props) => {
  const {
    state,
    dispatch,
    onContinue,
    serverError,
    logger,
  } = props;

  const classes = useRequestAccessStageStyles();
  const i18n = useContext(I18nContext);

  const { selectedCompanyPage } = state;
  const {
    Name: companyPageName,
    LogoDownloadUrl: companyPageLogoSrc,
    Location: industryLocation,
    IndustryType: industryType,
  } = selectedCompanyPage;

  const onClickRequestAccess = useCallback(() => {
    logger.trace('Start Connect company page');
    dispatch({ type: COMPANY_PAGE_LINKING_ACTIONS.START_SAVING_COMPANY_PAGE });
  }, [dispatch, logger]);

  useSaveCompanyPage(state, dispatch, onContinue, logger);

  return (
    <div className={mergeClasses('request-access-stage', classes.container)}>
      <div className={classes.contentContainer}>
        <div className={mergeClasses('info-session', classes.infoSection)}>
          <Image src={PERMISSION_REQUIRED_LOGO_SRC} className={classes.logo} />
          <Text as="h1" className={mergeClasses('permission-status-title', classes.title)}>
            {i18n.getString(_TL_('Permission required'))}
          </Text>
          <Text className={classes.description}>
            {i18n.getString(_TL_('Creating or modifying ads requires permissions granted by the company’s page administrator. You must have permission to be a paid media admin.'))}
          </Text>
        </div>
        <div className={classes.companyPageContainer}>
          <ComponyPageItem
            companyPageName={companyPageName}
            companyPageLogoSrc={companyPageLogoSrc}
            industryLocation={industryLocation}
            industryType={industryType}
          />
        </div>
      </div>
      {serverError}
      <div className={classes.actionsContainer}>
        <Button
          appearance="primary"
          className="request-access-button"
          onClick={onClickRequestAccess}
          aria-label={i18n.getString(_TL_('Permission required, click here to request permission.'))}
        >
          {i18n.getString(_TL_('Request permission'))}
        </Button>
      </div>
    </div>
  );
};

RequestAccessStage.propTypes = {
  state: PropTypes.shape({
    permissionStatus: PropTypes.string,
    selectedCompanyPage: PropTypes.shape({
      Id: PropTypes.string,
      Name: PropTypes.string,
      LogoDownloadUrl: PropTypes.string,
      Location: PropTypes.string,
      IndustryType: PropTypes.string,
    }),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  serverError: PropTypes.node,
  logger: PropTypes.shape({
    trace: PropTypes.func,
    error: PropTypes.func,
  }),
};

RequestAccessStage.defaultProps = {
  serverError: null,
  logger: {
    trace: _.noop,
    error: _.noop,
  },
};
